import { render, staticRenderFns } from "./VacationPeriodsList.vue?vue&type=template&id=7e159dbe&scoped=true"
import script from "./VacationPeriodsList.vue?vue&type=script&lang=js"
export * from "./VacationPeriodsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e159dbe",
  null
  
)

export default component.exports